import { render, staticRenderFns } from "./transferVchicleDeptMore.vue?vue&type=template&id=dcffdb36&scoped=true"
import script from "./transferVchicleDeptMore.vue?vue&type=script&setup=true&lang=js"
export * from "./transferVchicleDeptMore.vue?vue&type=script&setup=true&lang=js"
import style0 from "./transferVchicleDeptMore.vue?vue&type=style&index=0&id=dcffdb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcffdb36",
  null
  
)

export default component.exports